import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const Home = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.7 9.9999L12.7 1.9999C12.3 1.6999 11.8 1.6999 11.4 1.9999L2.39999 9.9999C1.99999 10.3999 1.89999 10.9999 2.29999 11.3999C2.49999 11.5999 2.79999 11.6999 2.99999 11.6999H3.99999V20.6999C3.99999 21.2999 4.39999 21.6999 4.99999 21.6999H19C19.6 21.6999 20 21.2999 20 20.6999V11.6999H21C21.6 11.6999 22 11.2999 22 10.6999C22 10.3999 21.9 10.1999 21.7 9.9999ZM15 19.6999H8.99999V16.6999C8.99999 14.9999 10.3 13.6999 12 13.6999C13.7 13.6999 15 14.9999 15 16.6999V19.6999Z"
      fill="currentColor"
    />
  </svg>
)

export default Home
